import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import TurnoCard from "../../components/TurnoCard/TurnoCard.jsx";
import "../BusquedaTurnos/BusquedaTurnos.css";
import { Typography, Grid } from "@mui/material";
import Cargando from "../../components/Loader/Loader.jsx";
import { buscarTurnos, obtenerSedes, obtenerPracticas } from "../../service/turnoService";
import { TextField, Button, Alert, Box, Skeleton, Pagination, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { useAuth } from "../../context/authContext.jsx";
import { useNavigate } from "react-router-dom";

const LIMITE = 8;

const BusquedaTurnos = ({ agregarTurno }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [medico, setMedico] = useState(searchParams.get("medico") || "");
  const [sede, setSede] = useState(searchParams.get("sede") || "");
  const [practica, setPractica] = useState(searchParams.get("practica") || "");
  const [fechaDesde, setFechaDesde] = useState(searchParams.get("fechaDesde") || "");
  const [fechaHasta, setFechaHasta] = useState(searchParams.get("fechaHasta") || "");

  const navigate = useNavigate();
  const { usuario } = useAuth();

  const [turnos, setTurnos] = useState([]);
  const [total, setTotal] = useState(0);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState("");
  const [sedes, setSedes] = useState([]);
  const [practicasDisponibles, setPracticasDisponibles] = useState([]);

const usuarioId = usuario?.pacienteId;

  const orden = searchParams.get("orden") || "";
  const pagina = Number(searchParams.get("pagina")) || 1;
  const totalPaginas = Math.ceil(total / LIMITE);


  useEffect(() => {

    async function cargarFiltros() {
        try {

            const listaSedes = await obtenerSedes();
            console.log(listaSedes);
            const listaPracticas = await obtenerPracticas();
            console.log(listaPracticas);
            console.log("SEDES", listaSedes);
            console.log("PRACTICAS", listaPracticas);

            setSedes(listaSedes);
            setPracticasDisponibles(listaPracticas);

        } catch (error) {
            console.error(error);
        }
    }

    cargarFiltros();

}, []);

  const handleAgregarTurno = (turno) => {
    if (!usuario) {
      navigate('/login', {
        state: {
          mensaje: 'Debes iniciar sesión para preseleccionar turnos.',
          from: window.location.pathname
        }
      });
      return;
    }
    agregarTurno(turno);
  };

  // Asegurarnos de que siempre haya una página en la URL
  useEffect(() => {
    if (!searchParams.has("pagina")) {
      const params = Object.fromEntries(searchParams);
      params.pagina = 1;
      setSearchParams(params, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  // Buscar turnos cuando cambian los searchParams (filtros, orden, paginación)
  useEffect(() => {
    async function buscar() {
      setCargando(true);
      setError("");

      try {
        const filtros = {
          medico: searchParams.get("medico") || "",
          sede: searchParams.get("sede") || "",
          practica: searchParams.get("practica") || "",
          fechaDesde: searchParams.get("fechaDesde") || "",
          fechaHasta: searchParams.get("fechaHasta") || "",
          orden: searchParams.get("orden") || "",
          pagina: Number(searchParams.get("pagina")) || 1,
          limite: LIMITE
        };

        console.log("Usuario logueado:", usuario);
        console.log("Usuario ID:", usuarioId);
        const datos = await buscarTurnos(usuarioId, filtros);
        console.log('Resultados de búsqueda:', datos);

        const resultados = datos.resultados || datos;


        
        const adaptados = resultados.map(turno => ({
          id: turno.id,
          medico: turno.medico,
          practica: turno.practica,
          sede: turno.sede,

          cobertura: turno.cobertura,
          costoBase: turno.costoBase,
          costo: turno.costoFinal,
          ahorro: turno.ahorro,

          fecha: new Date(turno.fechaHora).toLocaleDateString("es-AR"),
          hora: new Date(turno.fechaHora).toLocaleTimeString("es-AR", {
              hour: "2-digit",
              minute: "2-digit"
          }),
      }));

        setTurnos(adaptados);
        setTotal(datos.total || adaptados.length);
      } catch (e) {
        console.error("Error en búsqueda:", e);
        setError("No se pudieron cargar los turnos");
        setTurnos([]);
        setTotal(0);
      } finally {
        setCargando(false);
      }
    }

    buscar();
  }, [searchParams]);

  const aplicarFiltros = () => {
    const params = {};
    if (medico) params.medico = medico;
    if (sede) params.sede = sede;
    if (practica) params.practica = practica;
    if (fechaDesde) params.fechaDesde = fechaDesde;
    if (fechaHasta) params.fechaHasta = fechaHasta;
    if (orden) params.orden = orden;
    params.pagina = 1;
    setSearchParams(params);
  };

  const cambiarPagina = (nuevaPagina) => {
    const params = Object.fromEntries(searchParams);
    params.pagina = nuevaPagina;
    setSearchParams(params);
  };

  const cambiarOrden = (nuevoOrden) => {
    const params = Object.fromEntries(searchParams);
    if (nuevoOrden) {
      params.orden = nuevoOrden;
    } else {
      delete params.orden;
    }
    params.pagina = 1;
    setSearchParams(params);
  };

  return (
    <div className="busqueda-container">
      <Typography variant="h4" className="busqueda-titulo">
        Turnos Médicos Disponibles
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

        <Box
            sx={{
                p: 3,
                mb: 4,
                borderRadius: 3,
                backgroundColor: "#fff",
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)"
            }}
        >
        <Grid container spacing={2.5} alignItems="center">
        <Grid item xs={12} sm={6} lg={3}>
          <TextField fullWidth label="Médico" variant="outlined" value={medico} onChange={(e) => setMedico(e.target.value)} />
        </Grid>
        <Grid item xs={12} sm={6} lg={2}>
          <FormControl
              fullWidth
              variant="outlined"
          >              
        <InputLabel shrink>Sede</InputLabel>

              <Select
                value={sede}
                displayEmpty
                label="Sede"
                renderValue={(selected) =>
                    selected || "Todas las sedes"
                }
                onChange={(e) => setSede(e.target.value)}
            >
                  <MenuItem value="">
                      Todas
                  </MenuItem>

                  {sedes.map((sede) => (
                      <MenuItem
                          key={sede}
                          value={sede}
                      >
                          {sede}
                      </MenuItem>
                  ))}
              </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} lg={2}>
          <FormControl
              fullWidth
              variant="outlined"
          >
        <InputLabel shrink>Práctica</InputLabel>

              <Select
                value={practica}
                displayEmpty
                label="Práctica"
                renderValue={(selected) =>
                    selected || "Todas las prácticas"
                }
                onChange={(e) => setPractica(e.target.value)}
            >
                  <MenuItem value="">
                      Todas
                  </MenuItem>

                  {practicasDisponibles.map((practica) => (
                      <MenuItem
                          key={practica}
                          value={practica}
                      >
                          {practica}
                      </MenuItem>
                  ))}
              </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} lg={1}>
          <TextField fullWidth label="Fecha desde" variant="outlined" type="date" InputLabelProps={{ shrink: true }} value={fechaDesde} onChange={(e) => setFechaDesde(e.target.value)} sx={{ '& input[type="date"]': { color: fechaDesde ? 'inherit' : 'transparent' }, '& input[type="date"]:focus': { color: 'inherit' } }} />
        </Grid>
        <Grid item xs={12} sm={6} lg={1}>
          <TextField fullWidth label="Fecha hasta" variant="outlined" type="date" InputLabelProps={{ shrink: true }} value={fechaHasta} onChange={(e) => setFechaHasta(e.target.value)} sx={{ '& input[type="date"]': { color: fechaHasta ? 'inherit' : 'transparent' }, '& input[type="date"]:focus': { color: 'inherit' } }} />
        </Grid>

        
        <Grid item xs={12} sm={6} lg={2}>
        <FormControl sx={{ minWidth: 220 }}>
          <InputLabel id="orden-label">Ordenar por</InputLabel>
          <Select
            labelId="orden-label"
            label="Ordenar por"
            value={orden}
            onChange={(e) => cambiarOrden(e.target.value)}
          >
            <MenuItem value="">Sin ordenar</MenuItem>
            <MenuItem value="costoAsc">Costo: menor a mayor</MenuItem>
            <MenuItem value="costoDesc">Costo: mayor a menor</MenuItem>
            <MenuItem value="fechaAsc">Fecha: más próxima</MenuItem>
            <MenuItem value="fechaDesc">Fecha: más lejana</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      
        <Grid item xs={12} sm={2} lg={1}>
          <Button fullWidth variant="contained" color="primary" onClick={aplicarFiltros} sx={{ height: '56px' }}>Buscar</Button>
        </Grid>
      </Grid>

      </Box>
      {cargando ? (
        <Grid container spacing={3}>
          {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={item} style={{ width: "200px" }}>
              <Box sx={{ p: 2, border: '1px solid #ddd', borderRadius: 2, backgroundColor: '#fff' }}>
                <Skeleton animation="wave" height={40} width="80%" />
                <Skeleton animation="wave" height={20} width="60%" />
                <Skeleton animation="wave" height={20} width="50%" sx={{ mb: 2 }} />
                <Skeleton animation="wave" variant="rectangular" height={70} sx={{ mb: 2 }} />
                <Skeleton animation="wave" variant="rectangular" height={40} />
              </Box>
            </Grid>
          ))}
        </Grid>
      ) : (
        <>
          <Grid container spacing={3}>
            {turnos.map((turno, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={turno.id ?? index}>
                <TurnoCard turno={turno} agregarTurno={handleAgregarTurno} />
              </Grid>
            ))}
          </Grid>

          {totalPaginas > 0 && (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 4, gap: 2 }}>
              <Button 
                variant="outlined" 
                disabled={pagina <= 1} 
                onClick={() => cambiarPagina(pagina - 1)}
              >
                Anterior
              </Button>
              <Typography variant="body1" sx={{ fontWeight: 'bold', mx: 2 }}>
                Página {pagina} de {totalPaginas}
              </Typography>
              <Button 
                variant="outlined" 
                disabled={pagina >= totalPaginas} 
                onClick={() => cambiarPagina(pagina + 1)}
              >
                Siguiente
              </Button>
            </Box>
          )}
        </>
      )}
    </div>
  );
};

export default BusquedaTurnos;